"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnersQualifiedForJob = void 0;
const account_status_enum_1 = require("./account-status-enum");
const qualifications_job_partner_match_1 = require("./qualifications-job-partner-match");
const typeorm_1 = require("typeorm/browser");
let PartnersQualifiedForJob = class PartnersQualifiedForJob {
};
__decorate([
    (0, typeorm_1.Column)('varchar', {
        length: 18,
    }),
    __metadata("design:type", String)
], PartnersQualifiedForJob.prototype, "jobSfid", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean'),
    __metadata("design:type", Boolean)
], PartnersQualifiedForJob.prototype, "isRemote", void 0);
__decorate([
    (0, typeorm_1.Column)('varchar', {
        length: 18,
    }),
    __metadata("design:type", String)
], PartnersQualifiedForJob.prototype, "partnerId", void 0);
__decorate([
    (0, typeorm_1.Column)('varchar', {
        length: 18,
    }),
    __metadata("design:type", String)
], PartnersQualifiedForJob.prototype, "partnerStatus", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision'),
    __metadata("design:type", Number)
], PartnersQualifiedForJob.prototype, "partnerServiceArea", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
    }),
    __metadata("design:type", Number)
], PartnersQualifiedForJob.prototype, "distanceFromJob", void 0);
__decorate([
    (0, typeorm_1.Column)('jsonb'),
    __metadata("design:type", Array)
], PartnersQualifiedForJob.prototype, "rejectedJobs", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean'),
    __metadata("design:type", Boolean)
], PartnersQualifiedForJob.prototype, "inRejectedOpportunities", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean'),
    __metadata("design:type", Boolean)
], PartnersQualifiedForJob.prototype, "inRejectedBrands", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean'),
    __metadata("design:type", Boolean)
], PartnersQualifiedForJob.prototype, "inRejectedServices", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean'),
    __metadata("design:type", Boolean)
], PartnersQualifiedForJob.prototype, "hasAtLeastOneActiveContact", void 0);
PartnersQualifiedForJob = __decorate([
    (0, typeorm_1.ViewEntity)({
        dependsOn: [qualifications_job_partner_match_1.QualificationsJobPartnerMatch],
        expression: `
    SELECT
      job.sfid AS job_sfid,
      qjpm.is_remote,
      partner.id AS partner_id,
      partner.accountstatus__c AS partner_status,
      COALESCE(
        (
          SELECT
          CASE
            WHEN CURRENT_TIMESTAMP < time_stamp + interval '3 days'
            THEN
            CASE
              WHEN (
                SELECT
                CASE
                  WHEN EXISTS (
                    SELECT 1
                    FROM public.account partner_other
                    LEFT JOIN
                      public.qualifications_job_partner_match qjpm_other ON (
                      qjpm_other.job_sfid = job.sfid
                      AND qjpm_other.partner_id = partner_other.id
                      )
                    LEFT JOIN
                      public.partner_opportunity_radius por_other ON (
                      por_other.partner_id = partner_other.id
                      AND por_other.opportunity_id = job.opportunity__c
                      )
                    WHERE
                      partner_other.role = 'partner'
                      AND qjpm_other."match"
                      AND por_other.opportunity_id = job.opportunity__c
                      AND por_other.prioritized = true
                  ) THEN true
                  ELSE false
                END
              )
              THEN
              CASE
                WHEN (por.prioritized IS NULL OR NOT por.prioritized)
                THEN 0
                ELSE COALESCE (
                  por.radius,
                  partner.servicearea__c
                )
              END
            END
          END
          FROM public.log_entries
          WHERE job_api_id = job.api_id__c AND new_status = 'open'
          ORDER BY time_stamp ASC
          LIMIT 1
        ),
        (
          SELECT
          CASE
            WHEN CURRENT_TIMESTAMP < time_stamp + interval '3 days'
            THEN
            CASE
              WHEN
                COALESCE(
                  por.radius,
                  partner.servicearea__c
                ) > 50
              then 50
              else COALESCE(
                por.radius,
                partner.servicearea__c
              )
            end
          END
          FROM public.log_entries
          WHERE job_api_id = job.api_id__c AND new_status = 'open'
            AND (
                  NOT partner.bypass_local_prio_delay
                  OR
                  NOT por.bypass_local_prio_delay
            )
          ORDER BY time_stamp ASC
          LIMIT 1
        ),
        por.radius,
        partner.servicearea__c,
        50
      ) * 1000 AS partner_service_area,

      ST_Distance(
        ST_SetSRID(ST_MakePoint(partner.shippinglongitude, partner.shippinglatitude),4326)::geography,
        ST_SetSRID(ST_MakePoint(customer.shippinglongitude, customer.shippinglatitude),4326)::geography,
        false
      ) AS distance_from_job,

      ARRAY(
        SELECT
          json_build_object(
            'reason_category', reason_category,
            'reason_text', reason_text
          )
        FROM
          public.rejected_jobs rejected_jobs
        WHERE
          rejected_jobs.partner_sfid = partner.id
          AND rejected_jobs.job_api_id = job.api_id__c
        ORDER BY
          created_at desc
      ) AS rejected_jobs,

      EXISTS(
        SELECT
          TRUE
        FROM
          public.rejected_brands rb
        WHERE
          rb.partner_sfid = partner.id
          AND rb.brand_sfid = job.brand__c
      ) AS in_rejected_brands,

      EXISTS(
        SELECT
          TRUE
        FROM
          public.rejected_opportunities ro
        WHERE
          ro.partner_sfid = partner.id
          AND ro.opportunity_sfid = job.opportunity__c
      ) AS in_rejected_opportunities,

      EXISTS(
        SELECT
          TRUE
        FROM
          public.rejected_services rs
        INNER JOIN
          public.job_service__c js
          ON js.service__c = rs.service_sfid
             AND js.job_id = job.api_id__c
        WHERE
          rs.partner_sfid = partner.id
          AND rs.opportunity_sfid = job.opportunity__c
      ) AS in_rejected_services,

      EXISTS(
        SELECT
          TRUE
        FROM
          public.contact c
        WHERE
          c.accountid = partner.id
          AND c.access_to_web_app_requested__c = TRUE
      ) AS has_at_least_one_active_contact

    FROM
      public.job__c job
    CROSS JOIN
      public.account partner
    LEFT JOIN
      public.account customer ON (
        customer.id = job.customer__c
      )
    LEFT JOIN
      public.qualifications_job_partner_match qjpm ON (
        qjpm.job_sfid = job.sfid
        AND qjpm.partner_id = partner.id
      )
    LEFT JOIN
      public.partner_opportunity_radius por ON (
        por.partner_id = partner.id
        AND por.opportunity_id = job.opportunity__c
      )

    WHERE
      partner.role = 'partner'
      AND qjpm."match"
  `,
        name: 'partners_qualified_for_job',
        schema: 'public',
    })
], PartnersQualifiedForJob);
exports.PartnersQualifiedForJob = PartnersQualifiedForJob;
//# sourceMappingURL=partners-qualified-for-job.js.map